export default "__VITE_ASSET__C3Ee8xCa__"